import { gql } from "apollo-boost";

/* GRU 적립(NFC) */
export const GRU_SAVING_INFO_LIST_QUERY = gql`
  query AdminGruSavingInfoList(
    $commonStatus: String
    $keyword: String
    $skip: Int
    $first: Int
  ) {
    AdminGruSavingInfoList(
      commonStatus: $commonStatus
      keyword: $keyword
      orderBy: "id_DESC"
      skip: $skip
      first: $first
    ) {
      gruSavingInfos {
        id
        commonStatus
        name
        currency
        amount
        isLocationCheck
        gruSavingCount
        gruSavingAmount
        store {
          id
          name
          longitude
          latitude
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;

export const GRU_SAVING_INFO_DETAIL_QUERY = gql`
  query AdminGruSavingInfoDetail($id: String!) {
    AdminGruSavingInfoDetail(id: $id) {
      id
      commonStatus
      name
      currency
      amount
      isLocationCheck
      gruSavingCount
      gruSavingAmount
      store {
        id
        name
        longitude
        latitude
      }
      createdAt
      updatedAt
    }
  }
`;

export const GRU_SAVING_INFO_WRITE_QUERY = gql`
  mutation AdminGruSavingInfoWrite(
    $store: String!
    $amount: Int!
    $currency: String
    $isLocationCheck: Boolean
    $commonStatus: String
  ) {
    AdminGruSavingInfoWrite(
      store: $store
      amount: $amount
      currency: $currency
      isLocationCheck: $isLocationCheck
      commonStatus: $commonStatus
    )
  }
`;

export const GRU_SAVING_INFO_EDIT_QUERY = gql`
  mutation AdminGruSavingInfoEdit(
    $id: String!
    $store: String
    $amount: Int
    $currency: String
    $isLocationCheck: Boolean
    $commonStatus: String
  ) {
    AdminGruSavingInfoEdit(
      id: $id
      store: $store
      amount: $amount
      currency: $currency
      isLocationCheck: $isLocationCheck
      commonStatus: $commonStatus
    )
  }
`;

export const GRU_SAVING_INFO_DELETE_QUERY = gql`
  mutation AdminGruSavingInfoDelete($id: String!) {
    AdminGruSavingInfoDelete(id: $id)
  }
`;

/* 적립내역 */
export const GRU_SAVING_LIST_QUERY = gql`
  query AdminGruSavingList(
    $gruSavingInfo: String
    $commonStatus: String
    $keyword: String
    $startDate: String
    $endDate: String
    $skip: Int
    $first: Int
  ) {
    AdminGruSavingList(
      gruSavingInfo: $gruSavingInfo
      commonStatus: $commonStatus
      keyword: $keyword
      startDate: $startDate
      endDate: $endDate
      orderBy: "id_DESC"
      skip: $skip
      first: $first
    ) {
      gruSavings {
        id
        commonStatus
        currency
        amount
        longitude
        latitude
        gruSavingInfo {
          id
          name
          isLocationCheck
        }
        store {
          id
          name
          longitude
          latitude
        }
        user {
          id
          userId
          name
        }
        createdAt
      }
      count
      totalAmount
    }
  }
`;

export const GRU_SAVING_CANCEL_QUERY = gql`
  mutation AdminGruSavingCancel($id: String!) {
    AdminGruSavingCancel(id: $id)
  }
`;

/* 가맹점 검색 */
export const STORE_LIST_QUERY = gql`
  query AdminStoreList($keyword: String, $skip: Int, $first: Int) {
    AdminStoreList(
      keyword: $keyword
      orderBy: "id_DESC"
      skip: $skip
      first: $first
    ) {
      stores {
        id
        name
        longitude
        latitude
      }
      count
    }
  }
`;
